import logoImg from 'assets/images/popup-logo.svg';

import Icon from 'atoms/Icons/Icon';
import color from 'atoms/colors/colors';
import shadow from 'atoms/shadows/shadows';

import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';
import Image from 'quarks/Image';
import Link from 'quarks/Link';

import ComponentButton from 'components/Button/ComponentButton';

import type { ContentfulComponentCard } from 'graphqlTypes';
import type { FC } from 'react';

const ComparisonCard: FC<ContentfulComponentCard> = ({ backgroundIsDark, callToAction, companyName, ...props }) => (
  <Link href={callToAction?.link} textDecoration="none" width="100%">
    <Flex
      width="100%"
      height="100%"
      css={`
        padding: 10px;
      `}
    >
      <Flex
        width="100%"
        height="100%"
        flexDirection="column"
        overflowX="hidden"
        overflowY="hidden"
        transition="200ms ease-in-out"
        backgroundColor={backgroundIsDark ? 'gray-800' : 'common-white'}
        className="comparison-card"
        css={`
          box-shadow: ${shadow.sm};
          padding-top: 5px;

          &:hover {
            box-shadow: ${shadow.md};

            a {
              color: ${color.blue[900]};
            }
          }
        `}
        {...props}
      >
        <Flex
          position="relative"
          flexDirection="column"
          justifyContent="space-between"
          paddingY={24}
          paddingX={24}
          gap="16px"
          height="100%"
          maxHeight="fit-content"
          sm={{ maxHeight: 'calc(100% - 208px)' }}
        >
          <Flex
            flexDirection="column"
            gap="8px"
            textAlign="center"
            css={`
              img {
                margin: 0 auto;
              }

              h3 {
                margin: 10px 0;
              }

              a {
                height: max-content;
              }
            `}
          >
            <Image image={{ file: { url: logoImg } }} alt="Logo" width="180px" />
            <Heading as="h3" textStyle="h4" textColor={backgroundIsDark ? 'common-white' : 'gray-900'}>
              VS
            </Heading>
            {companyName && (
              <Heading as="h4" textStyle="h4" textColor={backgroundIsDark ? 'common-white' : 'gray-900'}>
                {companyName}
              </Heading>
            )}
            {callToAction && (
              <Flex gap="4px" alignItems="center" marginTop={32}>
                <ComponentButton key={callToAction?.contentful_id} {...callToAction} buttonColor="Gray 900 Link" />
                <Icon id="chevron-right" fill={color.gray[900]} size={20} />
              </Flex>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  </Link>
);

export default ComparisonCard;
